import { createAsyncThunk } from '@reduxjs/toolkit';
import MarketplaceCategoriesResource from 'api/service/MarketplaceCategoriesResource';
import { listProducts } from './marketplace-products';

export const listCategories = createAsyncThunk(
  'marketplaceManagement/listCategories',
  async (initialData, { rejectWithValue }) => {
    const marketplaceCategoriesResource = new MarketplaceCategoriesResource();
    const { offset = 0, query = '' } = initialData || {};
    const response = await marketplaceCategoriesResource.list({
      size: 10,
      includes: 'product_count,shared_count',
      search: query || '',
      offset,
    });

    if (response?.status === 200) {
      return { data: response?.data || [], offset: 10 + offset };
    }
    return rejectWithValue('Categories not found');
  }
);

export const listCategoriesNext = createAsyncThunk(
  'marketplaceManagement/listCategoriesNext',
  async (initialData, { rejectWithValue }) => {
    const marketplaceCategoriesResource = new MarketplaceCategoriesResource();
    const { offset = 0, query = '' } = initialData || {};
    const response = await marketplaceCategoriesResource.list({
      size: 10,
      includes: 'product_count,shared_count',
      search: query || '',
      offset,
    });

    if (response?.status === 200) {
      return { data: response?.data || [], offset: 10 + offset };
    }
    return rejectWithValue('Categories not found');
  }
);

export const listOptionCategories = createAsyncThunk(
  'marketplaceManagement/listOptionCategories',
  async (_, { rejectWithValue }) => {
    const marketplaceCategoriesResource = new MarketplaceCategoriesResource();
    const { status, data } = await marketplaceCategoriesResource.list({ size: 100, offset: 0 });
    if (status === 200) {
      return data;
    }
    return rejectWithValue('Categories not found');
  }
);

export const createCategory = createAsyncThunk(
  'marketplaceManagement/createCategory',
  async (initialData, { rejectWithValue }) => {
    const marketplaceCategoriesResource = new MarketplaceCategoriesResource();
    const { category } = initialData;
    const categoryData = {
      name: category?.name,
      icon: category?.icon,
    };
    const { status, data } = await marketplaceCategoriesResource.create(categoryData);
    if (status === 201) {
      return data;
    }
    return rejectWithValue('Category creation failed.');
  }
);

export const updateCategory = createAsyncThunk(
  'marketplaceManagement/updateCategory',
  async (initialData, { rejectWithValue, dispatch }) => {
    const marketplaceCategoriesResource = new MarketplaceCategoriesResource();
    const { category } = initialData;
    const categoryData = {
      name: category?.name,
      icon: category?.icon,
    };
    const { status, data } = await marketplaceCategoriesResource.category(category.id).update(categoryData);
    if (status === 200) {
      dispatch(listProducts());
      return data;
    }
    return rejectWithValue('Category updating failed.');
  }
);

export const deleteCategory = createAsyncThunk(
  'marketplaceManagement/deleteCategory',
  async (initialData, { rejectWithValue }) => {
    const marketplaceCategoriesResource = new MarketplaceCategoriesResource();
    const { id } = initialData;
    const { status } = await marketplaceCategoriesResource.category(id).delete();
    if (status === 202) {
      return id;
    }
    return rejectWithValue('Category deletion failed.');
  }
);
